/**
 * Single source of truth for chart colours. All chart components should use
 * getChartColors(branding) instead of hardcoded hex. Ensures charts respect
 * theme and white-label branding.
 */

import { deriveThemeTokens } from '../../constants/cyfDefaultBranding';

/**
 * Returns chart colour tokens from branding. No hardcoded hex; fallbacks come
 * from deriveThemeTokens (which uses cyfDefaultBranding when keys are missing).
 * @param {Object} branding - Redux branding state or { colors: { ... } }
 * @returns {{ titleColor: string, palette: string[], chart1: string, chart2: string, chart3: string, chart4: string, chart5: string, otherColor: string }}
 */
export const getChartColors = (branding) => {
  const colors = branding?.colors || {};
  const d = deriveThemeTokens(colors);

  return {
    titleColor: d.textColor || d.primaryHeaderText,
    palette: Array.isArray(d.palette) && d.palette.length ? d.palette : [d.chart1, d.chart2, d.chart3, d.chart4, d.chart5].filter(Boolean),
    chart1: d.chart1,
    chart2: d.chart2,
    chart3: d.chart3,
    chart4: d.chart4,
    chart5: d.chart5,
    otherColor: d.mutedForeground || d.mutedColor || d.chart5,
    dangerColor: d.dangerColor,
  };
};
